import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { changeLanguage, LANGUAGE } from "../../ducks/languageSelector.js";

import LanguageSelector from "./LanguageSelector.js";

const mapStateToProps = (state) => {
  return {
    language: state.languageSelector[LANGUAGE]
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ changeLanguage }, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelector);
